<template>
  <div class="preview-backdrop">
    <transition name="fade">
      <div class="initial-loader">
        <Spinner
          color="teal"
          v-show="!displayPreviewContainer"
        />
      </div>
    </transition> 
    <div
      class="preview-container"
      :style="{ opacity: displayPreviewContainer ? 1 : 0, filter: this.joinGameErrorMsg.length > 0 ? 'blur(4px)' : '' }"
    >
      <div class="preview-title">
        Game Setup
      </div>
      <div class="preview-tracks-wrapper">
        <VideoAndAudioPreview
          ref="videoAndAudioPreview"
          :redirectedFromCorrectPage="wasRedirectedFromLandingPage"
          @display-connect-video-modal="displayConnectVideoModal = $event"
          @load-local-tracks="localTracks = $event"
        />
      </div>
      <div class="preview-name-container">
        <FirstNameInput 
          v-model="firstName"
          :isDemo="true"
          :characterLimit="characterLimit"
        />
      </div>
      <div class="preview-play-music-container">
        <PlayMusicCheckbox 
          :value="isPlayMusicOptionChecked"
          @change="isPlayMusicOptionChecked = $event"
        />
      </div>
      <div class="preview-submit-container">
        <SpinnerButton
          class="preview-action-button"
          :isProcessing="isEnterRoomButtonClicked"
          :isDisabled="firstName.length > characterLimit || firstName.length == 0"
          @click="enterRoom"
        >
          Enter Room
        </SpinnerButton>
      </div>
    </div>
    <transition name="pop-from-top">
      <SetupErrorModal 
        v-if="joinGameErrorMsg.length > 0"
        :errorMsg="joinGameErrorMsg"
        @click="returnToLandingPage"
      />
    </transition>
    <transition name="pop-from-top">
      <EnableVideoModal
        v-if="displayConnectVideoModal && $refs.videoAndAudioPreview"
        @click="$refs.videoAndAudioPreview.getAndAttachLocalTracks"
      />
    </transition>
  </div>
</template>

<script>
import EnableVideoModal from '@/components/gameComponents/gameSetupComponents/EnableVideoModal';
import FirstNameInput from '@/components/gameComponents/gameSetupComponents/FirstNameInput';
import PlayMusicCheckbox from '@/components/gameComponents/gameSetupComponents/PlayMusicCheckbox';
import SetupErrorModal from '@/components/gameComponents/gameSetupComponents/SetupErrorModal';
import VideoAndAudioPreview from '@/components/gameComponents/gameSetupComponents/VideoAndAudioPreview';
import Spinner from '@/components/utilComponents/Spinner';
import SpinnerButton from '@/components/utilComponents/SpinnerButton';

export default {
  name: 'DemoSetupScreen',
  components: {
    EnableVideoModal,
    FirstNameInput,
    PlayMusicCheckbox,
    SetupErrorModal,
    VideoAndAudioPreview,
    Spinner,
    SpinnerButton
  },
  props: {
    joinGameRoomcode: String,
    wasRedirectedFromLandingPage: Boolean
  },
  data: () => ({
    localTracks: [],
    firstName: '',
    displayPreviewContainer: false,
    isPlayMusicOptionChecked: true,
    isEnterRoomButtonClicked: false,
    joinGameErrorMsg: '',
    characterLimit: 16,
    displayConnectVideoModal: false
  }),
  computed: {
  },
  methods: {
    enterRoom() {
      this.isEnterRoomButtonClicked = true;
      this.$router.push({
        name: 'demoweavr',
        params: {
          firstName: this.firstName,
          localTracks: this.localTracks,
          isMusicMutedInitially: !this.isPlayMusicOptionChecked,
          wasRedirectedFromDemoSetupScreen: true
        }
      });
      this.isEnterRoomButtonClicked = false;
    },
    returnToLandingPage() {
      this.$router.push({
        name: 'landing',
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'demoweavr') {
      this.localTracks.forEach(track => {
        track.stop();
      });
    }
    next();
  },
  created: function() {
    if (!this.wasRedirectedFromLandingPage) {
      this.returnToLandingPage();
    }
  },
  mounted: function() {
    this.$nextTick(async function() {
      if (this.wasRedirectedFromLandingPage) {
        this.displayPreviewContainer = true;
      }
    });
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/setup-styles.scss';
</style>
